/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detecting_ScenesInputs */

const en_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecting scene changes...`)
};

const fr_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection des changements de scène...`)
};

const de_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szenenänderungen erkennen...`)
};

const it_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento dei cambiamenti di scena...`)
};

const ru_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение изменений в сцене...`)
};

const es_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectando cambios de escena...`)
};

const zh_cn2_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测场景变化……`)
};

const ja_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーンの変化を検出しています...`)
};

const hi_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य परिवर्तन का पता लगाना...`)
};

const pt_pt2_detecting_scenes = /** @type {(inputs: Detecting_ScenesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectando mudanças de cena...`)
};

/**
* | output |
* | --- |
* | "Detecting scene changes..." |
*
* @param {Detecting_ScenesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const detecting_scenes = /** @type {((inputs?: Detecting_ScenesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detecting_ScenesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_detecting_scenes(inputs)
	if (locale === "de") return de_detecting_scenes(inputs)
	if (locale === "it") return it_detecting_scenes(inputs)
	if (locale === "ru") return ru_detecting_scenes(inputs)
	if (locale === "es") return es_detecting_scenes(inputs)
	if (locale === "zh-CN") return zh_cn2_detecting_scenes(inputs)
	if (locale === "ja") return ja_detecting_scenes(inputs)
	if (locale === "hi") return hi_detecting_scenes(inputs)
	if (locale === "pt-PT") return pt_pt2_detecting_scenes(inputs)
	return en_detecting_scenes(inputs)
});